/* eslint-disable */

export enum StorageKey {
  PRE_URL = 'preUrl',
  MME_TOKEN = 'MME-TOKEN',
  USER_ID = 'USER_ID',

  UTM_ACTIVITY_ID = 'utm_activityid',
  CAMPAIGN_CID = 'campaignCid',

  LOCATION_PERMISSION = 'locationPermission',

  GEO_CITY_NAME = 'init_local_city',
  GEO_CITY_NAME_EN = 'localPinYinGl',
  GEO_RESULT = 'positionCoords',
  DEALER_RESTORE_INFO = 'dealer_restore_info',

  // session storage
  WO_HEADER_FOOTER = 'woHeaderFooter',
  SOURCE_NAME = 'sourceName',
  IS_FROM_SALES_APP = 'isFromSalesApp',
  IS_FROM_DOU_YIN_MNP = 'isFromDouYinMNP',
  IS_PREVIEW = 'isPreview',
  IS_DISPLAY_CTA = 'isDisplayCTA',

  CURRENT_MODEL = 'currentModel',
  PHONE_NUMBER = 'mobile',
  REAL_NAME = 'realName',

  // for MMC in SessionStorage
  PRODUCT = 'product',
  VEHICLE = 'vehicle',
  SPECIFICATION = 'specification',
  EMAIL = 'email',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  GENDER = 'gender',
   
  // for recall 
  SEARCHED_RECALL_DATA = 'searchedRecallData',

  // for Favorites storage
  EXTERNAL_ID = 'externalId',
}
